import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-program-mgt',
  templateUrl: './program-mgt.component.html',
  styleUrls: ['./program-mgt.component.css']
})
export class ProgramMgtComponent implements OnInit {

  programList: any = [];
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  programId: any;

  constructor(public service: MainService, private router: Router) { }

  ngOnInit() {
    this.viewProgramList();
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.programList + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.programList = [];
        var regex = /(<([^>]+)>)/ig;
        res.result.forEach((ele: any) => {
          ele['update_des'] = ele.description.replace(regex, "");
          this.programList.push(ele)
        });
        this.total = res.paginationData.total;
        this.currentPage = res.paginationData.page;

      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  pagination(event: any) {
    this.programList = [];
    this.currentPage = event;
    this.viewProgramList()
  }

  // delete Program api integration 

  deleteProgram() {
    const data = {
      programId: this.programId,
      status: "DELETE"
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.deleteProgram, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.programList = res.result;
        $('#deleteUser').modal('hide')
        this.viewProgramList();
      }

    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  // searchFormReset() {
  //   if (this.searchForm.value.search) {
  //     this.searchForm.reset({
  //       search: '',
  //       disease: '',
  //       status: ''
  //     });
  //     this.getUserList()
  //   }
  // }


  deleteUserModal(id: any) {
    this.programId = id;
    $('#deleteUser').modal('show')
  }
}
